import React from 'react';
import Banner from '../components/Banner.js';
import Footer from '../components/Footer.js';

function MusicPage() {
  return (
    <div className="page music-page">
      <Banner selected="music" />
      <div className="contents">
        <h1>DOGS IN GREEN</h1>
        <p>
          Dogs In Green is an electronic indie rock band made up of Matteo
          Luban, Ben Kotzen, Brigitte Durieux, and Ben Vachon which has
          performed in states up and down the east coast.
        </p>
        <iframe
          width="45%"
          height="378"
          src="https://www.youtube.com/embed/B-d3dJgxdDg?si=iQiSfwXA-rZbFEIn"
          title="DiG Live at Model Peril"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          src="https://open.spotify.com/embed/artist/0EJVS7cvFdey9PAquxlAOY?utm_source=generator"
          title="DiG Spotify"
          width="45%"
          height="352"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        />
        <h1>I WANT A CAT</h1>
        <p>
          Featuring Ben Wetherbee on fiddle/vocals, Peter Barnick on drums, Mark
          Lang on guitar, and Ben Vachon on bass, I Want A Cat is part
          inner-cat-summoning ceremony, part jazz, part bluegrass, part punk,
          and part dance party based mostly out of Somerville and performing
          mainly around the eastern Massachusetts area. I Want A Cat shows are
          highly improvised multi-media performances.
        </p>
        <iframe
          width="45%"
          height="470"
          title="IWaC BandCamp"
          src="https://bandcamp.com/EmbeddedPlayer/album=2961527252/size=large/bgcol=ffffff/linkcol=0687f5/tracklist=false/transparent=true/"
          seamless
        >
          <a href="https://iwantacat.bandcamp.com/album/live-at-wmfo">
            Live at WMFO by I Want a Cat
          </a>
        </iframe>
        <iframe
          width="45%"
          height="378"
          src="https://www.youtube.com/embed/aUz_wsydZlE?si=2IwQ25vVp7SfNOw8"
          title="IWaC Live"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <h1>JOBIE</h1>
        <p>
          JOBIE is the songwriting project of Josie Aurthur, a singer-songwriter
          based in Boston writing and performing live shows both solo and with a
          backing band.
        </p>
        <iframe
          src="https://open.spotify.com/embed/artist/5BTDEC6oP0OdAK1CY6yMet?utm_source=generator"
          width="45%"
          height="352"
          title="JOBIE Spotify"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        />
        <iframe
          width="45%"
          height="315"
          src="https://www.youtube.com/embed/gJv8SI3IxeU?si=poT823sUf6T-ymO-"
          title="JOBIE Live"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <h1>THE WOLF IN OUR OWN BACKYARD</h1>
        <p>
          The Wolf in Our Own Backyard is the songwriting project of Kevin
          Gigler. Live shows are backed by Tom Varner, Seth Rabin, and Ben
          Vachon and performed in the Providence / Boston area.
        </p>
        <iframe
          width="45%"
          height="315"
          src="https://www.youtube.com/embed/LePngp8MLHo?si=PY_B5pxGnohWoFNG"
          title="TWIOOBY Live"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
        <iframe
          src="https://open.spotify.com/embed/artist/7oEXkANVF3Q0d4oz5OdHKt?utm_source=generator"
          width="45%"
          height="352"
          title="TWIOOBY Spotify"
          allowfullscreen=""
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        />
        <h1>BEVIS ARMADA</h1>
        <p>
          When I perform by myself or as the frontman of a hastily assembled
          band of my peers, I call myself Bevis Armada because it sounds silly
          and I can&apos;t take myself very seriously.
        </p>
        <iframe
          width="80%"
          height="378"
          src="https://www.youtube.com/embed/-yOOGH7PLTI?si=KAhVK-v_YXiBHq43"
          title="Live at Model Peril"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/j1Tnyk-T1GE?si=4aK_8HiNbEoQuLde"
          title="Earthworms In Love"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/6nrV-kNcPSk?si=Eq1SwFDU4vQuIvRQ"
          title="A Heart Beyond Its Prime"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/hX5txGXXZW4?si=bBv2e2PZyXcSS4N0"
          title="Atonement"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/Qqjjkz4AGnM?si=0-zaiY8T0Xst6C6d"
          title="Every Time We Touch"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/rQRm_fnfi0g?si=nT7N42DEwa1lj6eR"
          title="Better"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/r_iMVPelCSM?si=ELcWyjQ0ba7nbZ1g"
          title="There's Some Good"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/FClisKkgt5g?si=rDkWdPE9lcpUijuC"
          title="Write It On The Back Of My Hands"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/r92cF733Qck?si=rVsWuGY91Ro9LlHa"
          title="My Shiny Teeth And Me"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
        <iframe
          width="45%"
          height="252"
          src="https://www.youtube.com/embed/FIXeNFvkY3Y?si=lEG17MP45qfidPJS"
          title="Believe/ Take On Me"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
      </div>
      <Footer />
    </div>
  );
}

export default MusicPage;
